const NUMBER_0 = 0;
const NUMBER_1 = 1;
const NUMBER_2 = 2;
const NUMBER_9 = 9;
const NUMBER_10 = 10;
const NUMBER_12 = 12;
const NUMBER_25 = 25;
const NUMBER_56 = 56;
const NUMBER_100 = 100;
const NUMBER_200 = 200;
const NUMBER_1000 = 1000;
const NUMBER_2000 = 2000;
const NUMBER_3000 = 3000;
const NUMBER__100 = -100;
const NUMBER__101 = -101;
const NUMBER__102 = -102;
const NUMBER__103 = -103;
const NUMBER__104 = -104;
const NUMBER__107 = -107;
const NUMBER__108 = -108;
const NUMBER__109 = -109;
const NUMBER__110 = -110;
const NUMBER__111 = -111;
const NUMBER__112 = -112;
const NUMBER__113 = -113;
const NUMBER__114 = -114;
const NUMBER__115 = -115;
const NUMBER__117 = -117;
const NUMBER__118 = -118;
const NUMBER__119 = -119;
const NUMBER__135 = -135;
const NUMBER__136 = -136;
const NUMBER__199 = -199;
const NUMBER__201 = -201;
const NUMBER__202 = -202;
const NUMBER__300 = -300;
const NUMBER__301 = -301;
const NUMBER__504 = -504;
const NUMBER__888 = -888;
const NUMBER__999 = -999;
const NUMBER__1001 = -1001;
const NUMBER__1009 = -1009;
const NUMBER__1010 = -1010;
const NUMBER__1011 = -1011;
const NUMBER__1012 = -1012;
const NUMBER__1013 = -1013;
const NUMBER__1014 = -1014;
const NUMBER__1015 = -1015;
const NUMBER__1016 = -1016;
const NUMBER__1017 = -1017;
const NUMBER__1018 = -1018;
const NUMBER__1019 = -1019;
const NUMBER__1024 = -1024;
const NUMBER__1002 = -1002;
const NUMBER__1003 = -1003;
const NUMBER__1004 = -1004;
const NUMBER__1005 = -1005;
const NUMBER__1006 = -1006;
const NUMBER__1007 = -1007;
const NUMBER__1008 = -1008;
const NUMBER__1020 = -1020;
const NUMBER__1021 = -1021;
const NUMBER__1026 = -1026;
const NUMBER__1205 = -1205;
const NUMBER__5005 = -5005;
const NUMBER__5006 = -5006;
const NUMBER__5008 = -5008;
const NUMBER__5009 = -5009;
const NUMBER__5010 = -5010;
const NUMBER__5011 = -5011;
const NUMBER__5012 = -5012;
const NUMBER__5102 = -5102;
const NUMBER__5202 = -5202;
const NUMBER__100001 = -100001;
const NUMBER__100002 = -100002;
const NUMBER__100003 = -100003;
const NUMBER__100004 = -100004;
const NUMBER__100005 = -100005;
const NUMBER__100006 = -100006;
const NUMBER__100007 = -100007;
const NUMBER__100010 = -100010;
const NUMBER__100011 = -100011;
const NUMBER__100012 = -100012;
const NUMBER__100031 = -100031;
const NUMBER__100032 = -100032;
const NUMBER__100033 = -100033;
const NUMBER__100034 = -100034;
const NUMBER__100035 = -100035;
const NUMBER__100013 = -100013;
const NUMBER__100014 = -100014;
const NUMBER__100021 = -100021;
const NUMBER__200001 = -200001;
const NUMBER__200002 = -200002;
const NUMBER__200003 = -200003;
const NUMBER__200004 = -200004;
const NUMBER__200010 = -200010;
const NUMBER__200011 = -200011;
const NUMBER__200012 = -200012;
const NUMBER__200013 = -200013;
const NUMBER__200014 = -200014;
const NUMBER__257103 = -257103;
const NUMBER__257104 = -257104;
const NUMBER__261224 = -261224;
const NUMBER__261225 = -261225;
const NUMBER__266102 = -266102;
const NUMBER__266201 = -266201;
const NUMBER__266202 = -266202;
const NUMBER__266203 = -266203;
const NUMBER__266204 = -266204;
const NUMBER__266205 = -266205;
const NUMBER__266206 = -266206;
const NUMBER__266207 = -266207;
const NUMBER__266208 = -266208;
const NUMBER__266209 = -266209;
const NUMBER__266210 = -266210;
const NUMBER__266211 = -266211;
const NUMBER__266212 = -266212;
const NUMBER__266213 = -266213;
const NUMBER__266214 = -266214;
const NUMBER__267100 = -267100;
const NUMBER__267101 = -267101;
const NUMBER__267102 = -267102;
const NUMBER__267103 = -267103;
const NUMBER__267104 = -267104;
const NUMBER__267105 = -267105;
const NUMBER__267106 = -267106;
const NUMBER__267107 = -267107;
const NUMBER__267108 = -267108;
const NUMBER__267109 = -267109;
const NUMBER__267110 = -267110;
const NUMBER_1024 = 1024;
const NUMBER_30000 = 30000;
const NUMBER_300010 = -300010;
const NUMBER_300001 = -300001;
const NUMBER__300002 = -300002;
const NUMBER__300003 = -300003
const MAP_DEFAULT_CENTER_POSITION = [116.378398, 39.895231];

export default {
  NUMBER_0,
  NUMBER_1,
  NUMBER_2,
  NUMBER_9,
  NUMBER_10,
  NUMBER_12,
  NUMBER_25,
  NUMBER_56,
  NUMBER_100,
  NUMBER_200,
  NUMBER_1000,
  NUMBER_2000,
  NUMBER_3000,
  NUMBER__100,
  NUMBER__101,
  NUMBER__102,
  NUMBER__103,
  NUMBER__104,
  NUMBER__107,
  NUMBER__108,
  NUMBER__109,
  NUMBER__110,
  NUMBER__111,
  NUMBER__112,
  NUMBER__113,
  NUMBER__114,
  NUMBER__115,
  NUMBER__117,
  NUMBER__118,
  NUMBER__119,
  NUMBER__135,
  NUMBER__136,
  NUMBER__199,
  NUMBER__201,
  NUMBER__202,
  NUMBER__300,
  NUMBER__301,
  NUMBER__504,
  NUMBER__888,
  NUMBER__999,
  NUMBER__1001,
  NUMBER__1009,
  NUMBER__1010,
  NUMBER__1011,
  NUMBER__1012,
  NUMBER__1013,
  NUMBER__1014,
  NUMBER__1015,
  NUMBER__1016,
  NUMBER__1017,
  NUMBER__1018,
  NUMBER__1019,
  NUMBER__1024,
  NUMBER__1002,
  NUMBER__1003,
  NUMBER__1004,
  NUMBER__1005,
  NUMBER__1006,
  NUMBER__1007,
  NUMBER__1008,
  NUMBER__1020,
  NUMBER__1021,
  NUMBER__1026,
  NUMBER__1205,
  NUMBER__5005,
  NUMBER__5006,
  NUMBER__5008,
  NUMBER__5009,
  NUMBER__5010,
  NUMBER__5011,
  NUMBER__5012,
  NUMBER__5102,
  NUMBER__5202,
  NUMBER__100001,
  NUMBER__100002,
  NUMBER__100003,
  NUMBER__100004,
  NUMBER__100005,
  NUMBER__100006,
  NUMBER__100007,
  NUMBER__100010,
  NUMBER__100011,
  NUMBER__100012,
  NUMBER__100031,
  NUMBER__100032,
  NUMBER__100033,
  NUMBER__100034,
  NUMBER__100035,
  NUMBER__100013,
  NUMBER__100014,
  NUMBER__100021,
  NUMBER__200001,
  NUMBER__200002,
  NUMBER__200003,
  NUMBER__200004,
  NUMBER__200010,
  NUMBER__200011,
  NUMBER__200012,
  NUMBER__200013,
  NUMBER__200014,
  NUMBER__257103,
  NUMBER__257104,
  NUMBER__261224,
  NUMBER__261225,
  NUMBER__266102,
  NUMBER__266201,
  NUMBER__266202,
  NUMBER__266203,
  NUMBER__266204,
  NUMBER__266205,
  NUMBER__266206,
  NUMBER__266207,
  NUMBER__266208,
  NUMBER__266209,
  NUMBER__266210,
  NUMBER__266211,
  NUMBER__266212,
  NUMBER__266213,
  NUMBER__266214,
  NUMBER__267100,
  NUMBER__267101,
  NUMBER__267102,
  NUMBER__267103,
  NUMBER__267104,
  NUMBER__267105,
  NUMBER__267106,
  NUMBER__267107,
  NUMBER__267108,
  NUMBER__267109,
  NUMBER__267110,
  NUMBER_1024,
  NUMBER_30000,
  NUMBER_300001,
  NUMBER__300002,
  NUMBER__300003,
  NUMBER_300010,
  MAP_DEFAULT_CENTER_POSITION
};
